import { z } from "zod";

const CategorySchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});

const InventoryResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        id: z.string().uuid(),
        property_id: z.string().uuid(),
        category_id: z.string().uuid(),
        item_name: z.string(),
        price: z.string(), // API returns price as string with decimals
        created_at: z.string(),
        updated_at: z.string(),
        category: CategorySchema.optional(),
    }),
});

export { InventoryResponseSchema };
export type InventoryResponse = z.infer<typeof InventoryResponseSchema>;
